import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarDevolucion, ObtDevolucionesInternas } from "../../../../../API/Suministros/Devoluciones/DevolucionesInternasRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import DevolucionesInternasListado from "./Listado/DevolucionesInternasListado";
import ListadoDevolucionesInternasCRUD from "./DevolucionesInternasCRUD/ListadoDevolucionesInternasCRUD";
import RequisaMaterialCrud from "../RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";


const DevolucionesInternasScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [listadoDev, setListadoDev] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogRM, setShowDialogRM] = useState(false);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showDialogSalida, setShowDialogSalida] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [showRequisa, setShowRequisa] = useState(false);
  const [habilitar, setHabilitar] = useState(true);

  const confirmarEliminacion = () => {
    let encuentra = selectedDetalle.find(i => i?.IdEstadoFinanzas === 114)
    if(encuentra){
      toastShow(toast, 'error', 'Error', "Una de las devoluciones seleccionadas ya esta revisada por finanzas, no es posible eliminarla.")
    }else{
      setShowConfirmDialog(true);
    }
  };

  const onHideConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const onConfirmEliminacion = () => {
    setShowConfirmDialog(false);
    eliminarDevolucion();
  };

  const getInfo = async () => {
    setSelectedDetalle([])
    setLoading(true);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
 
    const fechas = getDatesProduccion(dates);
    const det = await ObtDevolucionesInternas(fechas)
    setListadoDev(det)
    setLoading(false)
  };

  const eliminarDevolucion = async () => {
    if (selectedDetalle.length > 0) {
      const detalles = selectedDetalle.map((select, index) => ({
        IdDevolucionDetalle: select.IdDevolucionDetalle,
        IdSalidaDetalle: select.IdSalidaDetalle,
        CantidadDevolucion: select.CantidadDevolucion,
        IdProducto: select.IdProducto,
      }));

      const response = await EliminarDevolucion(detalles);
      if (response[0]?.ESTADO === 1) {
        toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
        getInfo()
      } else {
        toastShow(toast, "error", 'Error al eliminar la devolución');
      }

    } else {
      toastShow( toast, "error", "No se puede eliminar", "Seleccione una devolución." );
    }
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && showRequisa !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogRM(null);
          setShowRequisa(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogRM(null);
      setShowRequisa(null);
      setHabilitar(true);
    }
  };


  useEffect(() => {
    // getInfo();
    setTitlePage(getLabel(baseLang, "devolucionesI", config.language));
  }, []);

    
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "devolucionesI", config.language)}</h2>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
            <Button
              icon="pi pi-times"
              type="button"
              className="p-button-danger listado__botones"
              onClick={confirmarEliminacion}
              tooltip="Cancelar"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              style={{ marginLeft: 1.5 }}
            />

              <ConfirmDialog
                visible={showConfirmDialog}
                onHide={onHideConfirmDialog}
                message="¿Estás seguro de que deseas eliminar?"
                header="Confirmación"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Sí"
                rejectLabel="No"
                accept={onConfirmEliminacion}
                reject={onHideConfirmDialog}
              />
            </div>
          }
          contenido={
            <div className="pt-4">
              <DevolucionesInternasListado
                listadoDev={listadoDev}
                getInfo={getInfo}
                selectedDetalle={selectedDetalle}
                setSelectedDetalle={setSelectedDetalle}
                showDialogSalida={setIngresoToShow}
                setShowDialogSalida={setShowDialogSalida}
                setShowDialogRM={setShowDialogRM}
                setShowRequisa={setShowRequisa}
                loading={loading}
              ></DevolucionesInternasListado>
            </div>
          }
        />

        <Dialog
          visible={showDialogRM}
          onHide={() => {
            cerrarConfirmacion();
          }}
          maximized={true}
          maximizable={true}
          closeOnEscape={false}
        >
          <RequisaMaterialCrud
            idIngreso={showRequisa}
            setIngresoToShow={setShowRequisa}
            showDialog={showDialogRM}
            // actualizarIngresosScreen={actualizarIngresosScreen}
            // setOrderToShow={setOrderToShow}
            // setOrdenDialog={setOrdenDialog}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        </Dialog>

      <Dialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        style={{ height: "90vh", width: "1400px" }}
      >
        <ListadoDevolucionesInternasCRUD actualizarScreen={getInfo} />
      </Dialog>
    </div>
  );
};

export default DevolucionesInternasScreen;
